import { useState } from "react"
import { formSchema } from "./receive.schema"
import { z } from "zod"
import ReceiveForm from "./receive.form"
import Loader from "@/components/layout/loader"
import PayForm from "@/pay/pay.form"
import { useWallets } from "@/api/wallets"
import { Network } from "@/config/tokens"
import { Button } from "@/components/ui/button"
import { DialogFooter } from "@/components/ui/dialog"

interface ReceiveFlowProps {
  onDone: () => void;
}

export default function ReceiveFlow({ onDone }: ReceiveFlowProps) {
  const [step, setStep] = useState<"form" | "pay-form">("form")
  const [form, setForm] = useState<z.infer<typeof formSchema> | null>(null)
  const [address, setAddress] = useState<string>("")
  const { wallet } = useWallets()

  if (!wallet) {
    return <Loader message="Loading..." />
  }

  const onSubmit = async (form: z.infer<typeof formSchema>) => {
    setForm(form)
    setAddress(
      form.network === Network.SOLANA ? wallet.solAddress : wallet.ethAddress,
    )
    setStep("pay-form")
  }

  if (step === "form") {
    return <ReceiveForm onSubmit={onSubmit} />
  } else if (step === "pay-form" && form) {
    return (
      <div className="flex flex-col gap-4">
        <p className="text-gray-300 text-sm">
          Use this address to receive payments:
        </p>
        <PayForm
          address={address}
          amount={Number(form.amount)}
          token={form?.token}
          network={form?.network}
        />
        <DialogFooter>
          <Button onClick={onDone} className="w-full">
            Done
          </Button>
        </DialogFooter>
      </div>
    )
  }
}
